import { useFlipperFlag } from 'hooks/useFlipperFlag'

export function useThirdPartyAnycableConsumer() {
  const useThirdPartyConsumer = useFlipperFlag('anycable_tp_client')
  if (useThirdPartyConsumer) {
    localStorage.setItem('anycable_tp_client', 'true')
  } else {
    localStorage.removeItem('anycable_tp_client')
  }
}
